import _ from 'lodash';
import { checkResourceTypeAuth } from '../serviceApi';

let widgetMixin = {
  emits: ['widgetCtrl'],
  props: {
    // 위젯 설정 정보
    configItem: {
      type: Object
    },
    // 위젯 설정 정보  index
    configIndex: {
      type: Number
    },
    // 공유 대시보드 여부
    sharedDashboard: {
      type: Boolean,
      default: false
    },
    // dashboard 검색시간
    searchDate: {
      type: Object
    },
    // 위젯 설정 모드 여부
    isSettingMode: {
      type: Boolean,
      default: false
    },
    isCustomDashboard: {
      type: Boolean,
      default: false
    }
  },
  provide() {
    return {
      isCustomDashboard: this.isCustomDashboard,
      sharedDashboard: this.sharedDashboard, // 공유 대시보드 여부
      getErrorMessage: () => this.errorMessage, // 위젯 권한 에러 메세지
      isSettingMode: this.isSettingMode // 위젯 설정 모드 여부
    };
  },
  watch: {
    configItem: {
      deep: true,
      immediate: false,
      async handler() {
        if (this.configItem.isApiCall) {
          await this.checkWidgetAuth();
          this.getData();
        }
      }
    }
  },
  created() {
    if (this.$util.isEmpty(this.configItem.chartId)) {
      this.configItem.chartId = 'widgetTmp' + Math.floor(Math.random() * 1000);
    }
  },
  async mounted() {
    await this.checkWidgetAuth();
    if (this.isWidgetAuth) this.getData();
  },
  computed: {
    // 위젯 높이
    widgetHeight: function () {
      const h = this.configItem.h || this.configItem.chartAttr.h || 2;
      return h * 129 + (h - 1) * 24;
    },
    // 위젯 속성
    chartAttr() {
      return this.configItem.chartAttr;
    },
    empty() {
      return false;
    },
    header() {
      return {};
    }
  },
  data() {
    return {
      loadingbar: false,
      isWidgetAuth: true,
      errorMessage: '', // 위젯 권한 에러 메세지
      notObjectItems: {
        // 하위 상품이 있는 상품에 한하여 API 요청시 object 값 제외유형
        Kubernetes: ['cluster'],
        'Load Balancer': ['service'],
        DataOps: ['service'],
        DataFlow: ['service'],
        QuickQuery: ['namespace'],
        DataWrangler: ['namespace']
      },
      ignoreCheckAuth: false
    };
  },
  methods: {
    // 삭제 예정
    ctrlClick(ctrl) {
      let ctrlObj = { type: ctrl, config: this.configItem };
      this.$emit('widgetCtrl', ctrlObj);
    },

    loading(show) {
      this.loadingbar = show;
    },

    async checkWidgetAuth() {
      this.isWidgetAuth = true;
      this.errorMessage = '';

      if (this.configItem.chartAttr.widget.type == 'TitleBoxWidget' || this.ignoreCheckAuth) return;

      if (!this.isCustomDashboard) {
        this.isWidgetAuth = true;
      }

      if (this.isWidgetAuth) {
        let resourceType = this.configItem.chartAttr.widget.options.resourceType;
        if (!this.$util.isEmpty(resourceType)) {
          // 상품유형 권한 체크
          await checkResourceTypeAuth(resourceType, this.header).catch((error) => {
            this.isWidgetAuth = false;
            this.errorMessage = 'message.accessErrorListMonitor';
          });
        }
      }
    },

    // 커스텀 위젯 파라메터 셋팅
    getProductResourceInfosConsoleParams(options) {
      const productResourceInfosConsole = [];

      for (let i in options.products) {
        let product = {
          objectList: [],
          productResourceId: options.products[i].key
            ? options.products[i].key
            : options.products[i].value
        };

        if (!_.isEmpty(options.objects)) {
          product.objectList = options.objects.map((object) => object.key || object.value);
        } else if (!_.isEmpty(options.objectItems)) {
          product.objectList = options.objectItems.map((object) => object.key || object.value);
        }

        productResourceInfosConsole.push(product);
      }

      const params = {
        metricDataConditionConsole: {
          metricKey: options.metricKey,
          productResourceInfosConsole
        }
      };
      this.$http.product.beforeCallMetricData(params);
      return _.get(params, 'metricDataConditionConsole.productResourceInfosConsole', []);
    }
  }
};
export default widgetMixin;
